// src/store/reducers.js
import { combineReducers } from "redux"

// Sirf authentication reducers rakho (baaki sab delete)
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"

const rootReducer = combineReducers({
  // Auth related – sirf yeh rakho
  Login,
  Account,
  ForgetPassword,
  Profile,
})

export default rootReducer
